import { __ } from '@wordpress/i18n';

const PromotionalSection = ({ section1: Section1, section2: Section2 }) => {
  return (
    <div className="promotional-section">
      <Section1 />
      <Section2 />
    </div>
  );
}

export default PromotionalSection;